import { isUndef, isNull } from '@aviata/type-guards';
import type { Dict } from '@aviata/platform-types';

import {
  lib as dictEntityLib,
  types as dictEntityTypes,
} from '../../../entities/dict';
import type {
  MismatchedCity,
  MismatchedCityWithDistance,
  MismatchedCityNames,
} from '../types';

const resolve = (dict: Dict.Entity, iata: dictEntityTypes.IATA) => {
  return (
    dictEntityLib.getCity(iata, dict).name ||
    dictEntityLib.getCityByAirport(iata, dict).name ||
    iata
  );
};

export const resolveMismatchedCityNames = (
  dict: Dict.Entity,
  mismatch: MismatchedCityWithDistance,
): MismatchedCityNames => ({
  distance: mismatch.distance,
  original: resolve(dict, mismatch.original_search),
  offered: resolve(dict, mismatch.offered_airport),
});

const findDistanceMismatch = (
  dict: Dict.Entity,
  cityMismatch: MismatchedCity,
) => {
  const { offered_airport: offeredAirport, original_search: originalSearch } =
    cityMismatch;
  const alternativeCities = dict.cities[originalSearch].alternative_cities;
  const city = alternativeCities?.find(city => city.iata === offeredAirport);

  return city ? Math.round(city.distance) : null;
};

export const extractMismatchData = (
  dict: Dict.Entity,
  cityMismatches: MismatchedCity[] | null,
  flightIdx: number,
) => {
  const mismatch = cityMismatches?.find(city => city.flight_idx === flightIdx);
  const distance = !isUndef(mismatch)
    ? findDistanceMismatch(dict, mismatch)
    : null;

  return !isNull(distance) && !isUndef(mismatch)
    ? { ...mismatch, distance }
    : null;
};
